'use strict';
(function () {
  var _controller = 'reservations.controller';
  angular.module('pentaApp').controller(_controller, controller);
  controller.$inject = ['$scope', 'reservation.resource', 'router.resource', '$timeout'];
  function controller($scope, reservationResource, routerResrouce, $timeout) {
    /// METHODS
    $scope.newRes = newRes;
    $scope.refresh = refresh;
    $scope.pay = pay;
    $scope.goTo = goTo;
    $scope.cancelReservation = cancelReservation;

    /// VARS
    $scope.reservations = null;
    $scope.routers = routerResrouce.query({ _controller: _controller });
    var event = window.queryStrings.event;
    var reservation = window.queryStrings.reservation;
    if(event) $timeout(function(){ newRes() }, 300);
    if(reservation) $timeout(function(){ newRes() }, 300);

    // WATCHERS
    $scope.$on('$destroy', onDestroy)
    $scope.$on('login', refresh);

    /// INIT
    refresh();


    /////////////////////

    var refreshing;
    function refresh(done) {
      if (refreshing && !refreshing.$resolved) return;
      if ($scope.$root.profile._id) refreshing = reservationResource.query({ myReservations: true, _controller: _controller, _ignoreVeil: typeof done === 'function' }, function (result) { 
        $scope.reservations = result; if (typeof done === 'function') done(); 
      });
    }

    function newRes() {
      appNavigator.pushPage('reservations/newReservation/newReservation.jade', { data: { onClose: refresh } });
    }

    function cancelReservation(reservation, index) {
      reservationResource.cancelReservation({ _id: reservation._id, _controller: _controller }, function () {
        $scope.reservations.splice(index, 1);
      })
    }

    function onDestroy() {
      $scope.$root.abortRequests(_controller);
    }

    function pay(reservation){
      appNavigator.pushPage('mercadoPagoByApi/mercadoPagoByApi.jade', { 
        data: { 
          amount: reservation.price,
          comment: i18next.t('El resumen de tu operación llegará al email con el cual hiciste la reserva o compra'),
          extraData: {
            type: 'RESERVATION',
            email: reservation.email,
            reservation: reservation._id
          },
          onClose: refresh 
        } 
      });
    }

    function goTo(url){
      var win = window.open(url, '_blank');
      win.focus();
    }
    //// FIN CONTROLLER
  }
})();
